/* Youghazi policy pages: sticky-header offset, real cookie-preference controls, contents highlighting.
   Policy text and navigation work without this script; it only enhances. */
(function () {
  'use strict';
  var page = document.querySelector('[data-policy-page]');
  if (!page) return;

  /* 1. Keep anchor targets clear of the sticky header. */
  function updateOffset() {
    var off = 16;
    var header = document.querySelector('.section-header');
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') off += Math.round(header.getBoundingClientRect().height);
    }
    page.style.setProperty('--policy-offset', off + 'px');
  }
  updateOffset();
  window.addEventListener('resize', updateOffset);
  window.addEventListener('load', updateOffset);
  var headerEl = document.querySelector('.section-header');
  if (headerEl && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(headerEl);

  /* 2. Cookie preferences: only the real Shopify consent interface is ever opened.
        Same detection as the footer's "Cookie preferences" control. */
  function prefsOpener() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return function () { window.privacyBanner.showPreferences(); };
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') {
      return function () { cp.showPreferences(); };
    }
    return null;
  }
  var note = page.querySelector('[data-policy-consent-note]');
  page.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-policy-consent]');
    if (!trigger) return;
    var open = prefsOpener();
    if (open) {
      e.preventDefault();
      if (note) note.hidden = true;
      open();
    } else if (note) {
      /* No consent interface available: do not fake one. The link still scrolls to "Changing your choice". */
      note.hidden = false;
    }
  });

  /* 3. Highlight the current section in the contents list (aria-current="location"). */
  var links = [].slice.call(page.querySelectorAll('[data-policy-toc-link]'));
  var heads = links.map(function (a) { return document.getElementById(a.getAttribute('data-policy-toc-link')); });
  var ticking = false;
  function mark() {
    ticking = false;
    var offset = parseInt(page.style.getPropertyValue('--policy-offset'), 10) || 110;
    var current = -1;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i] && heads[i].getBoundingClientRect().top <= offset + 8) current = i;
    }
    links.forEach(function (a, i) {
      if (i === current) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(mark); }
  }, { passive: true });
  mark();
})();
